import React from "react"
import { graphql } from "gatsby"
import { Asset } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"
import parse from "html-react-parser"
import AnimationButton from "./animation-button"

const ImageContentCta = ({
  title,
  button,
  images,
  video,
  colorBg = { red: 0, green: 0, blue: 0 },
  colorText = { red: 0, green: 0, blue: 0 },
  brand,
  isFruit,
}) => {

  let videoOverride = video
  if (brand === 'sunnyside' && isFruit) {
    videoOverride = `https://edlyn.atollon.au/SUN010-WebProductsVideo-Fruits-FA.mp4`
  }
  if (brand === 'sunnyside' && !isFruit) {
    videoOverride = `https://edlyn.atollon.au/SUN010-WebProductsVideo-Veggies-FA.mp4`
  }

  return (
    <section
      className={`image-content-cta ${brand ? brand : ""} ${brand === 'sunnyside' && video && 'sunnyside-video'}`}>
      <div className="image-content-cta__inner">
        <div className="image-content-cta__images">
          {!video && images?.length > 0 &&
            images.map((image, index) => (
              <div className="image-content-cta__image" key={index}>
                <Asset asset={image} />
              </div>
            ))}
          {videoOverride && <video src={videoOverride} autoPlay loop muted playsInline />}
        </div>

        <div className="image-content-cta__content">
          {title && <h2>{parse(title)}</h2>}
          {button?.length > 0 && (
            <AnimationButton
              className="btn btn--animation"
              to={
                button[0].link[0].externalLink
                  ? button[0].link[0].externalLink
                  : button[0].link[0].internalLink?.permalink
              }
            >
              {button[0].title}
            </AnimationButton>
          )}
        </div>
      </div>
    </section>
  )
}

export default ImageContentCta

export const query = graphql`
  fragment ImageContentCtaProps on DatoCmsImageContentCta {
    ... on DatoCmsImageContentCta {
      id
      title
      button {
        ...LinkWithTitleProps
      }
      video
      images {
        ...InternalAssetProps
      }
    }
  }
`
